import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export type SessionStatus =
  | "logged-in"
  | "logged-out"
  | "expired"
  | "uninitialized";

export type State = {
  serverError: boolean;
  sessionStatus: SessionStatus;
  sessionOffice: any;
};

const SLICE_NAME = "patientDashboard";

export const initialState: State = {
  serverError: false,
  sessionStatus: "uninitialized",
  sessionOffice: {},
};

export const patientDashboardSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setServerError: (state, action: PayloadAction<boolean>) => ({
      ...state,
      serverError: action.payload,
    }),
    setSessionStatus: (state, action: PayloadAction<SessionStatus>) => ({
      ...state,
      sessionStatus: action.payload,
    }),
    setSessionOffice: (state, action: PayloadAction<any>) => ({
      ...state,
      sessionOffice: action.payload,
    }),
  },
});

export const reducer = patientDashboardSlice.reducer;
export const { setServerError, setSessionStatus, setSessionOffice } =
  patientDashboardSlice.actions;

export const selectServerError = (state: RootState): boolean =>
  state.patientDashboard.serverError;

export const selectSessionStatus = (state: RootState): SessionStatus =>
  state.patientDashboard.sessionStatus;

export const selectSessionOffice = (state: RootState): any =>
  state.patientDashboard.sessionOffice;

export const patientDashboardReducer = patientDashboardSlice.reducer;
